import { SubscriptionPageSub } from "pages/shop/subscriptions/[slug]";
import { SubscriptionAddressForm } from "./SubscriptionAddressForm";

interface Props {
  subscription: SubscriptionPageSub;
}

export const SubscribeSection = ({ subscription }: Props) => {
  return (
    <>
      <h2 className='header bg-yellow-default px-1 pt-1'>Subscribe</h2>
      <SubscriptionAddressForm subscription={subscription} />
    </>
  );
};
